<template>
  <el-dialog
    :visible="true"
    v-bind="$attrs"
    :width="width"
    :close-on-click-modal="closeOnClickModal"
    v-on="$listeners"
    @close="$emit('close')"
  >
    <div slot="title">
      <p class="el-dialog__title">{{ title }}</p>
      <slot name="hint" />
    </div>
    <div v-loading="bodyLoading">
      <div :class="!bodyMaxHeight || 'overflow-auto'" :style="{ maxHeight: bodyMaxHeight }">
        <slot />
      </div>
    </div>
    <template #footer>
      <slot name="btnContainer">
        <div class="flex justify-end items-center">
          <BaseElButton v-if="!hideCancel" :loading="btn2Loading" :disabled="btn2Disabled" plain @click="$emit('cancel'), $emit('close')">
            {{ btn2 || $t('common.button.cancel.text') }}
          </BaseElButton>
          <BaseElButton v-if="!hideConfirm" :loading="btn1Loading" :disabled="btn1Disabled" type="primary" @click="$emit('confirm')">
            {{ btn1 || $t('common.button.confirm.text') }}
          </BaseElButton>
        </div>
      </slot>
    </template>
  </el-dialog>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'BaseDialog',
  props: {
    title: { type: String, default: '' },
    bodyLoading: { type: Boolean, default: false },
    btn1: { type: String, default: '' },
    btn2: { type: String, default: '' },
    btn1Loading: { type: Boolean, default: false },
    btn2Loading: { type: Boolean, default: false },
    btn1Disabled: { type: Boolean, default: false },
    btn2Disabled: { type: Boolean, default: false },
    hideConfirm: { type: Boolean, default: false },
    hideCancel: { type: Boolean, default: false },
    width: { type: String, default: 'fit-content' },
    closeOnClickModal: { type: Boolean, default: true },
    bodyMaxHeight: { type: String, default: '' },
  },
  emits: ['close', 'confirm', 'cancel'],
})
</script>

<style scoped lang="scss">

</style>
